import { render, staticRenderFns } from "./resetPasswordModal.vue?vue&type=template&id=68baf4f4&scoped=true&"
import script from "./resetPasswordModal.vue?vue&type=script&lang=js&"
export * from "./resetPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./resetPasswordModal.vue?vue&type=style&index=0&id=68baf4f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68baf4f4",
  null
  
)

export default component.exports